import BaseMessageHandler from '../BaseMessageHandler';
import { updateLanguage } from 'actions/user';

export default class Profile_UpdateLanguage extends BaseMessageHandler {
  success = () => {
    const { dispatch, message } = this;
    dispatch(updateLanguage(message.payload));
  };
}
